import { useEffect, useRef, useState } from 'react';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import FlagThree from '../FlagThree';
import FlagOne from '../FlagOne';
import FlagTwo from '../FlagTwo';

const TranslateSelect = () => {

    const flags = {
        en: <FlagOne />,
        hy: <FlagTwo />,
        ru: <FlagThree />
    };

    const { i18n } = useTranslation();

    const containerRef = useRef(null);

    const [selected, setSelected] = useState(flags[i18n.language]);
    const [isOpened, setIsOpened] = useState(false);

    const handleChangeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        setSelected(flags[lang]);
        setIsOpened(false);
    };

    useEffect(() => {
        const handleClose = (e) => {
            if(!containerRef.current.contains(e.target)) {
                setIsOpened(false);
            };
        };

         window.addEventListener('click', handleClose);

        return () => window.removeEventListener('click', handleClose);
    }, []);

    const pendingOptions = Object.entries(flags).map(([lang, component]) => 
        <li 
            key={lang}
            onClick={() => handleChangeLanguage(lang)} 
        >
            {component}
        </li>
    );

    return (
        <div className={styles.container} ref={containerRef}>
            <button onClick={() => setIsOpened(prev => !prev)} className={styles.selected}>
                {selected}
                 <ChevronDown 
                    style={{
                        transition: 'transform 0.2s ease-in-out',
                        transform: isOpened ? 'rotate(180deg)' : 'rotate(0deg)'
                    }}
                 />
            </button>
            <AnimatePresence>
                {
                    isOpened &&
                    <motion.ol 
                        className={styles.dropMain}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                    >
                        {pendingOptions}
                    </motion.ol>
                }
            </AnimatePresence>

        </div>
    )
};

export default TranslateSelect;